import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('pages.RequestFormPage.QBooksJournalEntryRequestForm.CurrencyDisclaimer', {
    autoRateDisclaimer: 'Currency rate for {date} provided by {rateProvider}, will be applied after submission.',
    manualRateDisclaimer:
        'Manual exchange rate will be applied, 1 {defaultCurrency} = {exchangeRate} {selectedCurrency}.',
    exchangeRateText: '1 {baseCurrency} = {rate} {currency}',
});
